import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { Button } from '../common/Button';

export const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  
  const isActive = (path: string) => location.pathname === path;
  
  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/services', label: 'Services' },
    { path: '/solutions', label: 'Solutions' },
    { path: '/contact', label: 'Contact' },
  ];
  
  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src="/logo.svg" 
                alt="Appeal Advantage Logo" 
                className="h-12 w-auto"
              />
              <span className="text-2xl font-bold">
                <span className="text-brand-blue">Appeal</span>
                <span className="text-brand-red"> Advantage</span>
              </span>
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-medium transition-colors ${
                  isActive(link.path)
                    ? 'text-brand-red'
                    : 'text-brand-blue hover:text-brand-red'
                }`}
              >
                {link.label}
              </Link>
            ))}
            
            <div className="flex items-center space-x-4">
              <a
                href="https://app.appealadvantage.com/login"
                className="text-brand-blue hover:text-brand-red font-medium transition-colors"
              >
                Sign In
              </a>
              <Button size="sm" onClick={() => navigate('/contact')}>
                Request Demo
              </Button>
            </div>
          </div>
          
          {/* Mobile menu button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <XMarkIcon className="w-6 h-6 text-brand-blue" />
            ) : (
              <Bars3Icon className="w-6 h-6 text-brand-blue" />
            )}
          </button>
        </div>
      </nav>
      
      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-gray-200 py-4">
          <div className="space-y-1 px-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block py-2 font-medium ${
                  isActive(link.path)
                    ? 'text-brand-red'
                    : 'text-brand-blue hover:text-brand-red'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="https://app.appealadvantage.com/login"
              className="block py-2 text-brand-blue hover:text-brand-red font-medium"
            >
              Sign In
            </a>
            <div className="pt-4">
              <Button 
                size="md" 
                className="w-full"
                onClick={() => {
                  setMobileMenuOpen(false);
                  navigate('/contact');
                }}
              >
                Request Demo
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

